export const isArrayEmpty = (arr) => {
  if (arr !== undefined && arr !== null && arr.length > 0) {
    return true;
  }
  return false;
};

export const getAccessToken = () => {
  var object = JSON.parse(localStorage.getItem("access_token"));
  if (object == null) {
    return null;
  }
  var dateString = null;
  var now = null;
  if (object) {
    dateString = object.expiration;
    now = new Date().getTime().toString();
  }
  if (!object || now > dateString) {
    if (object.userToken !== undefined) {
      localStorage.removeItem(object);
    }
    // return window.location.reload();
    return null;
  }
  return object.userToken === "undefined" || object.userToken === undefined
    ? null
    : object.userToken;
};

export const getCurrentLanguage = () => {
  // Get language from localStorage or default to 'de'
  const storedLanguage = localStorage.getItem('i18nextLng');
  if (storedLanguage) {
    // Extract only the language part (e.g., 'de' from 'de-AT')
    return storedLanguage.split('-')[0];
  }
  return 'de';
};
